/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Checkbox,
} from '@material-ui/core';
import _ from 'lodash';
import InputAdornment from '@mui/material/InputAdornment';
import {
  PLAN_TYPE_DATA,
  setPaymentListOptions,
  radioGroupPaymentGenerate,
  defaultTaskTypeValue,
} from './ConstantData';
import {
  setPlanType,
  setRebateProgram,
  getRebateProgramCodePRT,
  sysReminderSetupList,
  getAllTemplateType,
  dispatchCollectErrorMsg,
} from '../store/actions';
import SelectBoxWithoutBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithoutBox';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';
import { isNumeric } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const CollectionLetters = (props) => {
  const dispatch = useDispatch();
  const [curIndex, setCurIndex] = useState();
  const reminder_list = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.reminder_list
  );
  const getInputValue = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.getInputValue;
  });
  const [reminderList, setReminderList] = useState();
  const defaultPlanType = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const AllTemplateType = useSelector(
    (state) => state?.sharedState?.GeneratecdReducer?.TemplateType
  );
  const defaultRebateCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const planType = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.planType
  );
  const rebateProgram = useSelector(
    (state) => state?.sharedState?.ReminderSetupReducer?.rebateProgram
  );
  const rebateDropdownData = useSelector(
    (state) => state?.sharedState?.PeriodicReportReducer?.rebate_list
  );
  const getCollectErrorMsg = useSelector((state) => {
    return state.sharedState.ReminderSetupReducer.errorMsgCollect;
  });
  const newReminderPayload = {
    reminderName: '',
    rebateProgramCd: 'MDFD',
    templateId: '-1',
    paymentStatusTypeCd: '1',
    paidPct: '',
    owedAmt: '',
    daysSinceInvDistributed: '',
    usePriorQtrUraIfZeroInd: 0,
    daysSinceInvPrinted: null,
  };
  // dispatch plan type
  const dispatchPlanType = useCallback(
    (value) => {
      dispatch(setPlanType(value));
    },
    [planType]
  );
  // get all template list
  const templateNameListSet = React.useMemo(() => {
    let list = [];
    if (!_.isEmpty(AllTemplateType)) {
      list = !_.isEmpty(AllTemplateType.letterTemplate)
        ? _.map(AllTemplateType.letterTemplate, (val) => ({
            id: val.templateId,
            name: val.name,
            tempversion: val.templateVersion,
          }))
        : [];
    }
    list = _.union(list);
    list = _.orderBy(list, ['name'], ['asc']);
    return list;
  }, [AllTemplateType]);
  // dispatch rebate program
  const dispatchRebateProgram = useCallback(
    (value) => {
      dispatch(setRebateProgram(value));
    },
    [rebateProgram]
  );
  // dispatch default plan type
  React.useEffect(() => {
    if (!planType && defaultPlanType) {
      dispatchPlanType(defaultPlanType);
    } else if (!planType && (!defaultPlanType || defaultPlanType != -1)) {
      dispatchPlanType('FD');
    }
  }, [defaultPlanType]);
  // get reminder list data and assign to the state
React.useEffect(() => {
  if (reminder_list && reminder_list.length === 0) {
    setReminderList({
      ...newReminderPayload,
      rebateProgramCd: defaultRebateCd || 'MDFD',
    });
    handleFetchTemplateList(defaultRebateCd);
  }
}, [reminder_list, defaultRebateCd]);

  // get InputValue from Redux and assign to the state
  React.useEffect(() => {
    const inputValue = isNumeric(getInputValue);
    if (inputValue && getInputValue) {
      setCurIndex(parseInt(getInputValue));
    } else {
      setCurIndex(getInputValue);
    }
  }, [getInputValue]);
  // Template calling data
  const fetchAllTemplateList = (val) => {
    dispatch(
      getAllTemplateType({
        rebateProgramCd: val,
        templateTypeCd: ['COLLECT'],
      })
    );
  };
  // get rebate program code and dispatch template dropdown
  React.useEffect(() => {
    dispatchRebateProgram(defaultRebateCd);
    if (reminderList?.rebateProgramCd !== '-1') {
      fetchAllTemplateList(reminderList?.rebateProgramCd);
    } else if (defaultRebateCd) {
      fetchAllTemplateList(defaultRebateCd);
    }
  }, [defaultRebateCd || reminderList?.rebateProgramCd]);
  // dispatch rebate program based on plan type
  React.useEffect(() => {
    if (planType) dispatch(getRebateProgramCodePRT(planType));
    if (planType !== defaultPlanType) dispatchRebateProgram(null);
    else dispatchRebateProgram(defaultRebateCd);
  }, [planType]);

  const handleFetchTemplateList = (val) => {
    dispatch(
      getAllTemplateType({
        rebateProgramCd: val,
        templateTypeCd: ['COLLECT'],
      })
    );
  };
  // handle OnBlur reminder list text fields
  const handleOnBlur = (e) => {
    const type = e.target.name;
    const { value } = e.target;
    let localErr = getCollectErrorMsg || [];
    if (type === 'daysSinceInvDistributed') {
      if (value) {
        const rx = /^[0-9]{0,3}?$/;
        if (checkNumberValidation(rx, value)) {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvDistributed'
          );
        } else {
          localErr = localErr?.filter(
            (item) => item.field !== 'daysSinceInvDistributed'
          );
          localErr.push({
            field: 'daysSinceInvDistributed',
            errorType: 'daysSinceInvReq',
            message: `Item ${value} does not pass the validation test.`,
          });
        }
      } else if (!value) {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvDistributed'
        );
        localErr.push({
          field: 'daysSinceInvDistributed',
          errorType: 'daysSinceInvReq',
          message: 'Days since Invoice Distributed cannot be blank/ invalid',
        });
      } else {
        localErr = localErr?.filter(
          (item) => item.field !== 'daysSinceInvDistributed'
        );
      }
    }
    if (type === 'templateId') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'templateId');
        localErr.push({
          field: 'templateId',
          errorType: 'templateIdReq',
          message: 'Template Name is Required.',
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'templateId');
      }
    }
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateReq',
          message: 'Rebate Program is Required.',
        });
      } else {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchCollectErrorMsg(unique));
  };
  // check number validation
  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };
  // on change reminder list text fields
  const handleChange = (e) => {
    if (reminder_list?.length > 0) {
      reminder_list[curIndex - 1][e.target.name] = e.target.value;
      reminder_list[curIndex - 1].addEditRow = true;

      if (e.target.name === 'rebateProgramCd') {
        reminder_list[curIndex - 1].templateId = '-1';

        setReminderList({
          ...reminderList,
          [e.target.name]: e.target.value,
          templateId: '-1',
        });
      } else if (e.target.name === 'paymentStatusTypeCd') {
        reminder_list[curIndex - 1].paidPct = '';
        reminder_list[curIndex - 1].owedAmt = '';

        setReminderList({
          ...reminderList,
          [e.target.name]: e.target.value,
          owedAmt: '',
          paidPct: '',
        });
      } else {
        setReminderList({
          ...reminderList,
          [e.target.name]: e.target.value,
        });
      }
      dispatch(sysReminderSetupList(reminder_list));
      props.setDisableSaveCancel(true);
    } else {
      props.setDisableSaveCancel(false);
    }
  };
  // on change reminder list text field of perecent paid and amount owed
  const handleChangeInputAdornMent = (value, name) => {
    if (reminder_list.length != 0) {
      reminder_list[curIndex - 1][name] = value;
      reminder_list[curIndex - 1].addEditRow = true;

      setReminderList({
        ...reminderList,
        [name]: value,
      });
      dispatch(sysReminderSetupList(reminder_list));
    }
  };
  // on change reminder list text field of use prior checkbox
  const handleChangeusePriorQtrUraIfZeroInd = (value, name) => {
    let updateCheckValue = 1;
    if (value === 1) {
      updateCheckValue = 0;
    }
    reminder_list[curIndex - 1][name] = updateCheckValue;
    reminder_list[curIndex - 1].addEditRow = true;

    setReminderList({
      ...reminderList,
      [name]: updateCheckValue,
    });
    dispatch(sysReminderSetupList(reminder_list));
    props.setDisableSaveCancel(true);
  };
  // check value in proper format
  const checkValueRegx = (flType, val) => {
    let pass = false;
    let withDecimal = /^[0-9.]*$/;
    let withoutDecimal = /^[0-9.]*$/;
    if (flType === 'amountOwed') {
      withDecimal = /^[0-9]{0,9}(\.[0-9]{0,2})?$/;
      withoutDecimal = /^[0-9]{0,9}?$/;
    }
    if (flType === 'percentPaid') {
      withDecimal = /^[0-9]{0,5}(\.[0-9]{0,6})?$/;
      withoutDecimal = /^[0-9]{0,5}?$/;
    }
    if (val && val.includes('.')) {
      const rx = withDecimal;
      if (rx.test(val)) {
        pass = true;
      }
    } else {
      const rx_without = withoutDecimal;
      if (rx_without.test(val)) {
        pass = true;
      }
    }
    return pass;
  };
  return (
    <div data-testid="collectionletters-component">
      <div className="row mb-2">
        <div className="col-8">
          <fieldset className="custom-fieldset h-100">
            <legend className="same-font-family">
              Plan Type<span className="mandatory">*</span>
            </legend>
            <div className="sub-radio no-margin ">
              <FormControl>
                <RadioGroup
                  row
                  name="acc-plan-row-radio-buttons-group"
                  defaultValue={defaultPlanType || defaultTaskTypeValue}
                  value={planType || defaultTaskTypeValue}
                >
                  {PLAN_TYPE_DATA && !_.isEmpty(PLAN_TYPE_DATA)
                    ? PLAN_TYPE_DATA.map((v, i) => (
                        <FormControlLabel
                          value={v.value}
                          control={
                            <Radio
                              onChange={(e) => dispatchPlanType(v.value)}
                            />
                          }
                          label={v.name}
                          key={v.value && _.kebabCase(v.value)}
                          data-testid="radio-box-change-control"
                        />
                      ))
                    : null}
                </RadioGroup>
              </FormControl>
            </div>
          </fieldset>
        </div>
        <div className="col-4">
          <fieldset className="custom-fieldset">
            <legend className="same-font-family">
              Rebate Program<span className="mandatory">*</span>
            </legend>
            <div className="form-wrapper p-0 h-100">
              <div className="mui-custom-form with-select field-xl no-lbl d-flex align-items-center">
                <TextField
                  label="Rebate Program"
                  fullWidth
                  data-testid="rebate-programcd"
                  select
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    id: 'rebateProgramCd',
                  }}
                  onChange={(e) => {
                    handleChange(e);
                    // handleFetchTemplateList(e.target?.value);
                  }}
                  id="rebateProgramCd"
                  name="rebateProgramCd"
                  value={reminderList?.rebateProgramCd || defaultRebateCd || '-1'}
                     helperText={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field === 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field == 'rebateProgramCd' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value={
                      reminderList && reminderList.rebateProgramCd
                        ? reminderList.rebateProgramCd
                        : null
                    }
                    className="frr-dropdown-blank-item"
                  />
                  {rebateDropdownData?.length > 0
                    ? rebateDropdownData?.map((item) => {
                        return (
                          <MenuItem key={item.value} value={item.value}>
                            {`${item.label}`}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-4">
          <div
            className="form-wrapper p-0 mt-2"
            style={{ marginLeft: '-10px' }}
          >
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Reminder Description"
                  fullWidth
                  placeholder=""
                  data-testid="reminderName"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxlength: 255, 'aria-label': 'reminderName' }}
                  name="reminderName"
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onBlur={() => {
                    if (!templateNameListSet?.length > 0) {
                      handleFetchTemplateList(reminderList?.rebateProgramCd);
                    }
                  }}
                  value={reminderList?.reminderName || ''}
                
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="form-wrapper p-0 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Template Name"
                  fullWidth
                  required
                  data-testid="templateid"
                  select
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    id: 'templateId',
                  }}
                  id="templateId"
                  name="templateId"
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                  value={reminderList?.templateId || ''}
                  className={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field == 'templateId' ? 'mandate-fields' : null
                        )
                      : null
                  }
                  helperText={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field === 'templateId' ? l.message : null
                        )
                      : null
                  }
                  error={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field == 'templateId' ? l.message : null
                        )
                      : null
                  }
                >
                  <MenuItem
                    key=""
                    value={
                      reminderList && reminderList.templateId
                        ? reminderList.templateId
                        : null
                    }
                    className="frr-dropdown-blank-item"
                  />
                  {templateNameListSet?.length > 0
                    ? templateNameListSet?.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {`${item.name}`}
                          </MenuItem>
                        );
                      })
                    : null}
                </TextField>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-12">
          <fieldset
            data-testid="radio-box-component"
            className="radioBtnGroup custom-fieldset h-100"
          >
            <legend className="same-font-family">
              {radioGroupPaymentGenerate}
              <span className="mandatory">*</span>
            </legend>
            <div className="form-wrapper db">
              <div className="sub-radio no-margin">
                <FormControl>
                  <RadioGroup
                    row
                    name="paymentStatusTypeCd"
                    defaultValue={
                      reminderList && reminderList.paymentStatusTypeCd
                        ? reminderList.paymentStatusTypeCd
                        : null
                    }
                    value={reminderList?.paymentStatusTypeCd || ''}
                    required
                    data-testid="payment-radio-box-group-control"
                    onChange={handleChange}
                  >
                    {!_.isEmpty(setPaymentListOptions)
                      ? setPaymentListOptions.map((v, i) => (
                          <FormControlLabel
                            value={v.value}
                            control={<Radio />}
                            label={v.name}
                            key={v.value && _.kebabCase(v.value)}
                          />
                        ))
                      : null}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="row custom-search-dates">
              <div className="col-12 col-sm-6 col-md-4 frr-radio-100per-width">
                <SelectBoxWithoutBoxComponent
                  data-testid="percentPaid-ia"
                  labelName="percentPaid-ia"
                  className="frr-display-hidden-label"
                  select={false}
                  id="percentPaid-ia"
                  disabled={reminderList?.paymentStatusTypeCd !== '4'}
                  inputProps={{
                    maxLength: 12,
                    id: 'percentPaid-ia',
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        className="frr-percent-right-padding"
                        position="end"
                      >
                        %
                      </InputAdornment>
                    ),
                  }}
                  name="paidPct"
                  defaultValue={reminderList?.paidPct}
                  filterAction={(e) => {
                    const checkVal = checkValueRegx('percentPaid', e);
                    if (checkVal) {
                      handleChangeInputAdornMent(e, 'paidPct');
                    }
                  }}
                  // onBlurAction={(e) => {
                  //   // const rg = /^[0-9.]*$/;
                  //   const checkVal = checkValueRegx('percentPaid', e);
                  //   if (checkVal) {
                  //     handleOnBlurEvent('percentPaid', e);
                  //   }
                  // }}
                  // isError={getFieldError('percentPaid')}
                />
              </div>

              <div className="col-12 col-sm-6 col-md-4 frr-radio-100per-width">
                <SelectBoxWithoutBoxComponent
                  data-testid="amountOwed-ia"
                  labelName="amountOwed-ia"
                  id="amountOwed-ia"
                  className="frr-display-hidden-label"
                  select={false}
                  disabled={reminderList?.paymentStatusTypeCd !== '5'}
                  inputProps={{ maxLength: 14, id: 'amountOwed-ia' }}
                  InputProps={{
                    inputComponent: NumberFormatCustom,
                    startAdornment: (
                      <InputAdornment
                        className="frr-dollar-left-padding"
                        position="start"
                      >
                        $
                      </InputAdornment>
                    ),
                  }}
                  name="owedAmt"
                  defaultValue={reminderList?.owedAmt || ''}
                  filterAction={(e) => {
                    const checkVal = checkValueRegx('amountOwed', e);
                    if (checkVal) {
                      handleChangeInputAdornMent(e, 'owedAmt');
                    }
                  }}
                  // onBlurAction={(e) => {
                  //   // const rg = /^[0-9.]*$/;
                  //   const checkVal = checkValueRegx('amountOwed', e);
                  //   if (checkVal) {
                  //     handleOnBlurEvent('amountOwed', e);
                  //   }
                  // }}
                  // isError={getFieldError('amountOwed')}
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mb-2">
        <div className="col-4">
          <div
            className="form-wrapper p-0 mt-2"
            style={{ marginLeft: '-10px' }}
          >
            <div className="mui-custom-form input-md field-xl">
              <div>
                <TextField
                  label="Days since Invoice Distributed"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  data-testid="days-sinceinv-printed"
                  required
                  inputProps={{
                    maxlength: 4,
                    'aria-label': 'daysSinceInvDistributed',
                  }}
                  name="daysSinceInvDistributed"
                  value={reminderList?.daysSinceInvDistributed || ''}
                  onChange={handleChange}
                  onBlur={handleOnBlur}
                  helperText={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field === 'daysSinceInvDistributed'
                            ? l.message
                            : null
                        )
                      : null
                  }
                  className={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field == 'daysSinceInvDistributed'
                            ? 'mandate-fields'
                            : null
                        )
                      : null
                  }
                  error={
                    getCollectErrorMsg?.length > 0
                      ? _.map(getCollectErrorMsg, (l) =>
                          l.field == 'daysSinceInvDistributed'
                            ? l.message
                            : null
                        )
                      : null
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="mui-custom-form with-select input-md mui-custom-form-with-margin2 m-0 mt-5">
            <div className="sub-radio text-black sub-label">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    data-testid="usePriorQtrUraIf-zero-ind"
                    name="usePriorQtrUraIfZeroInd"
                    checked={reminderList?.usePriorQtrUraIfZeroInd === 1}
                    onChange={() => {
                      handleChangeusePriorQtrUraIfZeroInd(
                        reminderList?.usePriorQtrUraIfZeroInd,
                        'usePriorQtrUraIfZeroInd'
                      );
                    }}
                    required
                  />
                }
                label="Use Prior Quarter URA if Zero Ind"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CollectionLetters;
